import { ArrowBackRounded } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import VirtualFencePolygonMap from './VirtualFencePolygonMap';

export const VirtualFencePolygon = (props: any) => {
  const isEdit = !!(props.match.params && props.match.params.id);

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', padding: '24px' }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Box display="flex" alignItems="center" minWidth={0}>
          <IconButton
            onClick={() => props.history.goBack()}
            aria-label="goBack"
            size="large"
            sx={{ color: 'text.secondary' }}
          >
            <ArrowBackRounded />
          </IconButton>
          <Typography
            id="virtualFencePolygon.home.createOrEditLabel"
            data-cy="VirtualFencePolygonCreateUpdateHeading"
            variant="h5"
            sx={{
              fontSize: '1.5rem',
              color: 'text.secondary',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {isEdit ? 'Editar cerca poligonal' : 'Nova cerca poligonal'}
          </Typography>
        </Box>
      </Box>
      <VirtualFencePolygonMap props={props} />
    </Box>
  );
};

export default VirtualFencePolygon;
